import { Add, ContactPhone } from "@mui/icons-material";
import { Badge, Box, Button, Divider, Typography } from "@mui/material";
import React from "react";
import FormDrawer from "components/Shared/FormDrawer";
import { toast } from "react-toastify";
import AdditionalNumberForm from "./AdditionalNumberForm";
import AdditionalNumberList from "./AdditionalNumberList";
import { useUpdateBranchMutation } from "store/services/branchApi";
import { useAuth } from "hooks";

const BranchAdditionalNumberTab = ({ branchDetail }) => {

  const [showNumberForm, setShowNumberForm] = React.useState(false);

  const [updateNumber, { isLoading: updatingNumber }] =
    useUpdateBranchMutation();
  
   const {isAdmin} = useAuth()

  const handleUpdateNumber = async (data) => {
    try {
      await updateNumber({
        ...data,
        _id: branchDetail?._id,
      }).unwrap();
      toast.success("Number added successfully");
      setShowNumberForm(false);
    } catch (err) {
      toast.error(err?.data?.message ?? err?.message ?? "Couldn't add Number!");
    }
  };

  const handleCancelNumber = () => {
    setShowNumberForm(false);
  };

  return (
    <>
      <Box
        display="flex"
        alignItems="end"
        justifyContent="space-between"
        padding={2}
      >
        <Box display="inline-flex" alignItems="center" gap={1.5}>
          <Badge
            badgeContent={branchDetail?.additionalNumbers?.length}
            color="primary"
          >
            <ContactPhone style={{ color: "gray" }} />
          </Badge>

          <Typography style={{ fontWeight: 500 }}>Additonal Numbers</Typography>
        </Box>

        {isAdmin && (
          <Button
            startIcon={<Add />}
            variant="outlined"
            onClick={() => setShowNumberForm(true)}
          >
            Additonal Number
          </Button>
        )}
      </Box>

      <Divider />
      <AdditionalNumberList
        number={branchDetail?.additionalNumbers}
        branchDetail={branchDetail}
        isBusy={updatingNumber}
      />

      <FormDrawer
        title="Add Additional Number"
        open={showNumberForm}
        onClose={handleCancelNumber}
      >
        <AdditionalNumberForm
          branchDetail={showNumberForm}
          isBusy={updatingNumber}
          onSubmit={(data) => handleUpdateNumber(data)}
          onCancel={handleCancelNumber}
        />
      </FormDrawer>
    </>
  );
};

export default BranchAdditionalNumberTab;
